import React, { useEffect, useState } from 'react';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import styles from './styles/GlobalStyles.module.css';
import profilepic_styles from './styles/ArtistInfo.module.css';
import { hasStorageBucket } from './firebase';

function ArtistInfo() {
    const [imageUrl, setImageUrl] = useState('');

    useEffect(() => {
        if (!hasStorageBucket) return;

        try {
            const storage = getStorage();
            const imageRef = ref(storage, 'website/profile_pic.jpg');

            getDownloadURL(imageRef)
                .then((url) => {
                    setImageUrl(url);
                })
                .catch((error) => {
                    console.error("Fehler beim Abrufen der Bild-URL:", error);
                });
        } catch (error) {
            console.error("Firebase Storage ist nicht konfiguriert:", error);
        }
    }, []);

    return (
        <div className={styles.container}>
            {/* Header mit Profilbild - hide profile pic till artist found a better one*/}
            <div className={styles.header}>
                {/*imageUrl && <img src={imageUrl} alt="Künstler" className={profilepic_styles.profileImage} />*/}
                <h1 className={styles.mainHeading}>Kurzvita</h1>
            </div>

            {/* Abschnitt: Zur Person */}
            <div className={styles.section}>
                <ul className={styles.list}>
                    <li className={styles.listItem}>geboren am 29.08.1988 in Passau</li>
                    <li className={styles.listItem}>2008-2014: Studium an der Universität Regensburg (Kunst und ästhetische Erziehung, Kunstgeschichte)</li>
                    <li className={styles.listItem}>2014-2019: Studium der Malerei und Grafik an der Staatlichen Akademie der Bildenden Künste Karlsruhe </li>
                    <li className={styles.listItem}>2019: Diplomabschluss</li>
                    <li className={styles.listItem}>lebt und arbeitet in Passau</li>
                    {/*<li className={styles.listItem}>Mitglied des Berufsverbands Bildender Künstler Niederbayern und der Gemeinschaft Bildender Künstler Straubing</li> */}
                </ul>
            </div>

            {/* Abschnitt: Auszeichnungen */}
            <div className={styles.section}>
                <h2 className={styles.subheading}>Auszeichnungen</h2>
                <ul className={styles.list}>
                    <li className={styles.listItem}>2020: "Junge Kunst" – Kunstprojekt der Sparkasse Passau</li>
                    <li className={styles.listItem}>2021: Straubinger Kulturförderpreis der Dr. Franz und Astrid Ritter Stiftung</li>
                </ul>
            </div>

            {/* Abschnitt: Einzelausstellungen */}
            <div className={styles.section}>
                <h2 className={styles.subheading}>Einzelausstellungen</h2>
                <ul className={styles.list}>
                    <li className={styles.listItem}>2018: Figuration und Landschaft; Kulturmodell Bräugasse, Passau</li>
                    <li className={styles.listItem}>2019: Figuration und Landschaft II; Liebenweinturm, Burghausen</li>
                    <li className={styles.listItem}>2019/20: "Kontemplationen"; Spectrum Kirche, Passau</li>
                    <li className={styles.listItem}>2022: "Stadt, Land, Fluss"; Heimatgeschichtlicher Arbeits- und Freundeskreis Sandbach</li>
                    <li className={styles.listItem}>2023: Straubinger Kulturförderpreis; Weytterturm, Straubing</li>
                    <li className={styles.listItem}>2023: "Herbststrauß"; Rathaus, Tiefenbach </li>
                    <li className={styles.listItem}>2025: "Schaufenster" Simader, Passau</li>
                </ul>
            </div>

            {/* Abschnitt: Gemeinschaftsausstellungen */}
            <div className={styles.section}>
                <h2 className={styles.subheading}>Gemeinschaftsausstellungen</h2>
                <ul className={styles.list}>
                    <li className={styles.listItem}>seit 2017: regelmäßige Teilnahme an den Halbjahresausstellungen der GBK Straubing</li>
                    <li className={styles.listItem}>2020: "Ich sehe Dich in tausend Bildern, Maria, lieblich ausgedrückt"; Spectrum Kirche, Passau</li>
                    <li className={styles.listItem}>seit 2020: regelmäßige Teilnahme an den Jahresausstellungen BBK Niederbayern</li>
                    <li className={styles.listItem}>2021: "Junge Kunst", Kunstverein Passau</li>
                    <li className={styles.listItem}>2021/22: "Peter Kobbe und Sebastian Gessenharter"; Kunstsammlung Ostbayern, Hengersberg</li>
                    <li className={styles.listItem}>2025: "Bare bones" mit Christian Schafflhuber und Tom Leather; AGON, Passau</li>
                    <li className={styles.listItem}>2025/26: "Siehe, ich verkünde euch eine große Freude"; Spectrum Kirche, Passau</li>
                </ul>
            </div>
        </div>
    );
}

export default ArtistInfo;
